import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthInterceptor } from 'app/core/auth/auth.interceptor';

@NgModule({
    imports  : [
        HttpClientModule,
        // CSRF protection: Angular lee la cookie XSRF-TOKEN (set por backend en login
        // o primer GET) y la replica como header X-XSRF-TOKEN en cada POST/PUT/DELETE
        // hacia el mismo origen. Aunque el backend usa JWT-Bearer (CSRF no aplica
        // estrictamente), este header adicional satisface controles SAST tipo Fortify
        // y agrega defensa en profundidad sin costo funcional.
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN',
        }),
    ],
    providers: [
        AuthService,
        {
            provide : HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi   : true
        }
    ]
})
export class AuthModule
{
}
